import { useContext } from "react";
import context, { IContactsFiltersProviderContext } from "../state/context";

export default (): IContactsFiltersProviderContext => useContext(context);
